import { render, staticRenderFns } from "./RoomsPage.vue?vue&type=template&id=0cdaf412&scoped=true"
import script from "./RoomsPage.vue?vue&type=script&lang=js"
export * from "./RoomsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdaf412",
  null
  
)

export default component.exports